import React from 'react';
import { LoginForm } from './LoginForm';

export const LoginPage: React.FC = () => {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-background p-4 pt-[var(--safe-top)] pb-[var(--safe-bottom)] pl-[max(1rem,var(--safe-left))] pr-[max(1rem,var(--safe-right))]">
      <div className="w-full max-w-md space-y-6">
        <div className="text-center space-y-2">
          <div className="h-12 w-12 rounded-xl bg-primary text-primary-foreground font-black text-2xl flex items-center justify-center mx-auto shadow-md">
            H
          </div>
          <h1 className="text-2xl font-bold tracking-tight text-foreground">Sign in to Helios</h1>
          <p className="text-sm text-muted-foreground">Unified Enterprise Suite Architecture</p>
        </div>

        <LoginForm />

        <div className="text-center text-xs text-muted-foreground">
          Protected by Argon2id, Opaque Sessions, & SameSite=Lax Host-Only Cookies.
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
